<template>
  <div class="vip-popup-overlay" v-if="value" @click.self="handleClose">
    <div class="vip-popup">
      <div class="vip-content">
        <h2 class="vip-title">开通VIP解锁全部技巧</h2>
        <p class="vip-desc">口诀技巧 轻松答题</p>
        <div class="vip-icon">
          <img src="@/assets/icon/vipTips.png" alt="" srcset="" />
        </div>
        <button class="vip-subscribe-btn" @click="handleSubscribe">立即开通</button>
      </div>
    </div>
    <img src="@/assets/icon/modal_close.png" alt="" srcset="" class="close-btn" @click="handleClose" />
  </div>
</template>

<script>
  export default {
    name: 'VipPopup',
    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      handleClose() {
        this.$emit('input', false)
      },
      handleSubscribe() {
        this.handleClose()
        this.$router.push({ path: '/order/goods' })
      },
    },
  }
</script>

<style scoped>
  .vip-popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    animation: fadeIn 0.3s;
  }

  .vip-popup {
    background: #eef6ff;
    border-radius: 12px;
    padding: 30px 25px;
    width: 420px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    position: relative;
    animation: slideUp 0.3s;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    box-sizing: border-box;
    overflow: hidden;
    img {
      width: 231px;
      height: 254px;
    }
  }

  .close-btn {
    width: 40px;
    height: 40px;
    margin-top: 20px;
    cursor: pointer;
  }

  .vip-title {
    color: #ff5722;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 8px;
    text-align: center;
  }

  .vip-desc {
    color: #727273;
    font-size: 20px;
    text-align: center;
    margin-bottom: 20px;
  }

  .vip-icon {
    display: flex;
    justify-content: center;
    margin: 20px auto;
    width: 300px;
    height: 200px;
    img {
      width: 90%;
      height: 90%;
    }
  }

  .icon-house {
    position: relative;
    width: 80px;
    height: 70px;
  }

  .roof {
    width: 0;
    height: 0;
    border-left: 40px solid transparent;
    border-right: 40px solid transparent;
    border-bottom: 30px solid #26c6da;
    margin: 0 auto;
  }

  .body {
    width: 60px;
    height: 40px;
    background: #29b6f6;
    margin: 0 auto;
    position: relative;
    top: -2px;
  }

  .door {
    width: 20px;
    height: 25px;
    background: #ffa726;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .vip-tip {
    color: #999;
    font-size: 14px;
    text-align: center;
    margin: 15px 0 25px;
    position: relative;
  }

  .vip-tip:before {
    content: '车辆无';
    position: absolute;
    top: -30px;
    left: 50%;
    transform: translateX(-50%);
    color: #ccc;
    font-size: 12px;
  }

  .vip-subscribe-btn {
    background: linear-gradient(135deg, #ff7e5f, #feb47b);
    color: white;
    border: none;
    width: 100%;
    padding: 14px;
    border-radius: 30px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    box-shadow: 0 4px 15px rgba(255, 126, 95, 0.4);
    transition: all 0.3s;
  }

  .vip-subscribe-btn:active {
    transform: translateY(0);
  }

  /* 动画效果 */
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
</style>
